import React, { useState } from 'react';
import CustomInput from '../../components/form/CustomInput';
import { Link, useNavigate } from 'react-router-dom';
import CustomButtonConfirm from '../../components/form/CustomButtonConfirm';
import { loginSuccess, loginUser } from '../../store/auth/login/action';
import * as Yup from "yup";
import { useFormik } from "formik";
import { useDispatch } from 'react-redux';
import { postLoginToken, resetPassword,/*Funcion parar reset*/ } from '../../helpers/configRoutes/backend_helper'

const Login = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false)

    const validation = useFormik({
        initialValues: {
            email: '',
            password: '',
        },
        validationSchema: Yup.object({
            email: Yup.string().email("Correo electrónico no válido").required("Ingresa tu correo electrónico"),
            password: Yup.string().when('forgotPassword', {
                is: false,
                then: Yup.string().required("Ingresa tu contraseña")
            })
        }),
        onSubmit: async (values, { setErrors }) => {
            setLoading(true)
            const response = await resetPassword(values)
            if (response.status == true) {
                navigate('/login')
            }
            setLoading(false)
        }
    });

    return (
        <div className="min-h-screen w-full bg-cs-bg flex flex-col justify-center px-5">

            {/* Card */}
            <div className="bg-cs-surface rounded-2xl p-6 shadow-soft animate-fadeIn">

                <h1 className="text-lg font-semibold text-cs-dark mb-1">
                    Recuperar acceso
                </h1>

                <p className="text-sm text-cs-muted mb-6">
                    Ingresa tu correo para recibir el código
                </p>

                <form
                    className="flex flex-col gap-4"
                    onSubmit={(e) => {
                        e.preventDefault()
                        validation.handleSubmit()
                    }}
                >
                    <CustomInput
                        placeholder="Correo electrónico"
                        type="email"
                        name="email"
                        error={validation.errors.email}
                        value={validation.values.email}
                        handleChange={validation.handleChange}
                    />

                    <CustomButtonConfirm
                        loading={loading}
                        textLoad="Enviando…"
                        text="Enviar código"
                        className="w-full mt-2"
                    />
                </form>
            </div>

            {/* Acción secundaria */}
            <button
                type="button"
                onClick={() => navigate('/login')}
                className="mt-6 text-center text-sm text-cs-muted"
            >
                Volver al inicio de sesión
            </button>

        </div>
    );
}

export default Login;
